import type { UserResponse } from 'types/session/user'

import type { Session } from '../types/session'

export const userResponseToSession = (user: UserResponse): Session => {
	return {
		token: user.oAuth.access,
		email: user.email ?? null,
		hashedEmail: user.hashedEmail ?? null,
		name: user.firstName ?? null,
		surname: user.lastName ?? null,
		externalId: user.externalIdentifiers.consumerRepository.externalId ?? null,
		logged: true,
		isReady: true,
		accountId: user.id,
	}
}
